var SENTRY_RELEASE;SENTRY_RELEASE={name: "LookIn | Lookiero", version: "1.0.0"};